<div class="cv-multiselect-search-component wrapper">
	<div #dropdownLabel class="label">
		<label *ngIf="label && label.length > 0">
			{{label}} <span class="required-text" *ngIf="required">*</span>
		</label>
	</div>
	<div #dropdownButton class="search-bar"
			 (click)="disabled || toggleMenu()"
			 [ngStyle]="{ width: width }"
			 [ngClass]="{'input-invalid': (!isValid() || !valid), 'disabled': disabled}">
		<div class="items-container">
			<span *ngFor="let option of currentValues"
						class="tag"
						(click)="disabled || toggleOption(false, option, $event)">
			{{option[optionText]}}
				<i class="action-clear fa fa-times"
					 *ngIf="!disabled"></i>
			</span>
		</div>
		<i class="fa dropdown-icon"
			 [ngClass]="{'fa-caret-down': !isOpen, 'fa-caret-up': isOpen,
			 'adjust-position': (!currentValues || !currentValues.length)}"></i>
	</div>

	<div #dropdownMenu
			 class="dropdown-menu"
			 [ngStyle]="{ width: width }">
		<div class="input-container">
			<i class="fa fa-search"></i>
			<cv-input #cvInput
								[className]="'action-toggle'"
								[placeholder]="placeholder"
								[hidden]="disabled"
								[type]="'search'"
								(textCleared)="onFilter($event)"
								(controlKeyup)="onFilter($event)">
			</cv-input>
		</div>
		<div *ngIf="!loading">
			<div *ngFor="let option of filteredOptions; let i = index"
					#dropdownOption [tabIndex]="0"
					(click)="toggleOption(true, option, $event)"
					(keyup)="tabNavigationOnArrowKeyEvents($event, option, i)"
					class="action-select item-value dropdown-item" >
				<label>
					{{option[optionText]}}
				</label>
			</div>
		</div>
		<div *ngIf="(!filteredOptions || !filteredOptions.length) && !loading"
				 class="no-items-legend">
			No items found
		</div>
		<div *ngIf="loading" class="no-items-legend">
			Loading...
		</div>
	</div>
</div>